import {Map} from 'immutable';
import get from 'lodash/get';
import {createSelector, defaultMemoize} from 'reselect';
import {getProcedureOrphanSteps} from 'sweet-graphs';

import {gt} from 'app/utils/i18n';

import * as utils from './utils';

import type {RootState} from 'app/store/root-reducer';
import type {
  BasicTeamSerializedType,
  ProcedureSerializedType,
  ProcedureStepType,
  ProcessSerializedType,
} from 'sweet-types';

export const currVersionTooltipTextSelector = createSelector<
  {
    approved_at: null | string;
  },
  string,
  {
    approved_at: null | string;
  }
>(
  (procedure) => procedure,
  (procedure) =>
    get(procedure, 'approved_at') ? gt('Live') : gt('Most recent draft')
);

export const denormalizeDocument = (
  basicTeams: Map<string, Map<string, BasicTeamSerializedType>>,
  document: ProcedureSerializedType | ProcessSerializedType
) => {
  return {
    ...document,
    team_names: document.team_names.map<BasicTeamSerializedType>(
      ({id}) =>
        basicTeams.get(id.toString(), Map({})).toJS() as BasicTeamSerializedType
    ),
  };
};
export const denormalizeProcedureFactory =
  (state: RootState) => (procedure: ProcedureSerializedType) =>
    denormalizeDocument(state.teamsArea.get('basicTeams'), procedure);

export const getMemoizedProcedureOrphanSteps = defaultMemoize(
  (steps: Array<ProcedureStepType>, stepsBlockedAt: string | null | boolean) =>
    getProcedureOrphanSteps(steps, stepsBlockedAt), // this equality check function is called with all inputs in turn.
  (prev, current) =>
    Array.isArray(prev) && Array.isArray(current)
      ? utils.procedureStructureIsEqual(prev, current)
      : prev === current
);
